module.exports = __webpack_public_path__ + "img/index-section6-friend12_a.a87fe54f.svg";